import { FiFileText } from "react-icons/fi";
import { GrTemplate } from "react-icons/gr";
import { MdOutlinePriceCheck } from "react-icons/md";
import { VscInspect } from "react-icons/vsc";
import "../../../css/IconStyle.css";

const ChargeConfirmationIcon = () => {
  return <MdOutlinePriceCheck size={28} className="sidebar-icon" />;
};

export default ChargeConfirmationIcon;

export const TemplateCreationIcon = () => {
  return <GrTemplate size={23} className="sidebar-icon" />;
};

export const favTemplateCreationIcon = () => {
  return <GrTemplate size={23} className="sidebar-icon" fill="red" />;
};

export const DocumentManagementIcon = () => {
  return <FiFileText size={25} />;
};

export const InspectionProcessIcon = () => {
  return <VscInspect size={25} />;
};

